// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2-sUG","info":"UpdateTermsInfo_info__3g0PA"};